import fetchServer from "../fetchServer";

export default async function getEsimBooking(id) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching eSIM booking!",
    data: null,
  };

  if (!id) {
    result.msg = "Missing eSIM booking id";
    return result;
  }

  try {
    const res = await fetchServer({
      method: "GET",
      url: `/product/v1/esim/booking/${id}?populate=account`,
    });
    const apiMessage = res?.data?.message;

    if (res?.data && !res?.data?.error) {
      result = {
        return: 1,
        msg: apiMessage || "Fetched eSIM booking successfully",
        data: res?.data?.data || res?.data,
      };
    } else {
      result.msg =
        apiMessage ||
        res?.data?.error ||
        "Something went wrong fetching eSIM booking!";
    }
  } catch (err) {
    result.msg = "Network Error!";
  }

  return result;
}
